import { render, staticRenderFns } from "./MyContactNotes.vue?vue&type=template&id=5a401c1b&scoped=true&"
import script from "./MyContactNotes.vue?vue&type=script&lang=js&"
export * from "./MyContactNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a401c1b",
  null
  
)

export default component.exports